<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
        <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-md-6">
                <h5 class="headingValue">Permission for Temporary Registration (PTR) Register</h5>
            </div>
            <div class="col-md-6 text-right">
                <!-- <button class="globalBtn clearBtn" routerLink="../login" (click)="back()">Back</button> -->
                <button class="globalBtn clearBtn" (click)="back()">Back</button>
            </div>
        </div>
        <hr>
    </div>
</header>
<div class="container h-100" style="background: #eee;padding: 15px;">
    <div class="row">
        <div class="col-md-12 p-0">
            <div class="card">
                <form id="guruId" [formGroup]="formGroupId" role="form" autocomplete="off"
                    class="has-validation-callback">

                    <div class="bt-tab-content-main">

                        <div class="tab-content" style="margin-top: 15px">
                            <div id="signin">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">Institution Category <span
                                                    class="text-danger">*</span></label>

                                                    <select class="form-control" tabindex="10" formControlName="institutionTypeId"  [ngClass]="{ 'is-invalid': f.institutionTypeId.invalid && (f.institutionTypeId.dirty || f.institutionTypeId.touched) }">
                                                        <option value="" disabled selected style="color:orange">Select Institution</option>
                                                        <option *ngFor="let sec of institutionTypeList" [value]="sec.institutionTypeId">
                                                            {{sec.institutionTypeName}}
                                                        </option>
                                                    </select>
                                                <div *ngIf="submitted && formGroupId.controls['institutionTypeId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                         Institution Type Required
                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                           
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">
                                                Association/Hospital/Organization/Others/Trust/University <span
                                                    class="text-danger">*</span></label>

                                            <input id="name" name="name" tabindex="1" formControlName="name"
                                                placeholder="Association/ Hospital/Organization/Others/Trust/University"
                                                type="text" class="form-control"
                                                maxlength="70" (keypress)="keyPressAlphaNumericWithCharacters($event)" >
                                                <div *ngIf="submitted && formGroupId.controls['name'].hasError('required') "
                            class="failed-validation" class="errorColor">
                         Institution Name Required
                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">Email Address <span
                                                    class="text-danger">*</span></label>
                                            <input id="userEmail" name="userEmail" tabindex="2" formControlName="userEmail"
                                                placeholder="Email Address" type="text" class="form-control" value=""
                                                maxlength="255"
                            [ngClass]="{ 'is-invalid': f.userEmail.invalid && (f.userEmail.dirty || f.userEmail.touched) }"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['userEmail'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Email Address Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['userEmail'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Email Address  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">

                                        
                                    </div>
                                    
                                </div>
                              
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="required">Address Line 1 <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" placeholder="Address Line 1"
                                                formControlName="addressLine1"
                                                [ngClass]="{ 'is-invalid': f.addressLine1.invalid && (f.addressLine1.dirty || f.addressLine1.touched) }"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['addressLine1'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Address Line 1 Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['addressLine1'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Address Line 1
                                            </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="required">Address Line 2 <span
                                                    class="text-danger"></span></label>
                                            <input type="text" class="form-control" placeholder="Address Line 2"
                                                formControlName="addressLine2" [ngClass]="{ 'is-invalid': f.addressLine2.invalid && (f.addressLine2.dirty || f.addressLine2.touched) }">
                                                <div *ngIf="submitted && formGroupId.controls['addressLine2'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Address Line 2 Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['addressLine2'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Address Line 2
                                            </div> 
                                            </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                      
                                    </div>
                                    <div class="col-md-6">
                                       
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group" tabindex="1">
                                            <label for="ethicCountry" class="required">Country <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="countryId" (change)="findState()" disabled
                                            [ngClass]="{ 'is-invalid': f.countryId.invalid && (f.countryId.dirty || f.countryId.touched) }">
                                                <option value="" disabled selected>Select Country</option>
                                                <option  *ngFor=" let  details of countryList" [value]="details.countryId">
                                                    {{details.countryName}}</option>
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['countryId'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            Country Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['countryId'].invalid 
                                        && (formGroupId.controls['countryId'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['countryId'].errors.required">
                                            <b> Country is required.</b>
                                        </div>  
                                    </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6" *ngIf="!stateName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">State/UT <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="stateId" (change)="findCity()"
                                            [ngClass]="{ 'is-invalid': f.stateId.invalid && (f.stateId.dirty || f.stateId.touched) }">
                                                <option value="" disabled selected>Select State</option>
                                                <option  *ngFor="let details of stateList" [value]="details.stateId">
                                                    {{details.stateName}}</option>
                                               
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['stateId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            State/UT is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['stateId'].invalid 
                        && (formGroupId.controls['stateId'].dirty )"
                        class="invalid-feedback">
                        <div *ngIf="submitted && formGroupId.controls['stateId'].errors.required">
                            <b> State/UT is required.</b>
                        </div>  
                    </div> 
                                        </div>
                                    </div>

                                    <div class="col-md-6" *ngIf="stateName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">State/UT <span
                                                    class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" placeholder="State Name"
                                                    formControlName="stateName" maxlength="70"
                                                    [ngClass]="{ 'is-invalid': f.stateName.invalid && (f.stateName.dirty || f.stateName.touched) }">
                                                    <div *ngIf="formGroupId.controls['stateName'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            State/UT is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['stateName'].invalid 
                        && (formGroupId.controls['stateName'].dirty)"
                        class="invalid-feedback">
                        <div *ngIf="submitted && formGroupId.controls['stateName'].errors.required">
                            <b> State/UT is required.</b>
                        </div>  
                    </div> 
                                        </div>
                                    </div>

                                </div>
                                
                                <div class="row">
                                    <div class="col-md-6" *ngIf="!cityName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">City <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="cityId" [ngClass]="{ 'is-invalid': f.cityId.invalid && (f.cityId.dirty || f.cityId.touched) }">
                                                <option value="" disabled selected>Select City</option>
                                                <option  *ngFor="let details of cityList" [value]="details.cityId">
                                                    {{details.name}}</option>
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['cityId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            City is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['cityId'].invalid 
                                        && (formGroupId.controls['cityId'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['cityId'].errors.required">
                                            <b> City is required.</b>
                                        </div>  
                                    </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6" *ngIf="cityName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">City <span
                                                    class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" placeholder="City Name"
                                                    formControlName="cityName" maxlength="70"
                                                    [ngClass]="{ 'is-invalid': f.cityName.invalid && (f.cityName.dirty || f.cityName.touched) }">
                                                    <div *ngIf="submitted && formGroupId.controls['cityName'].hasError('required') "
                                                    class="failed-validation" class="errorColor">
                                                 City is Required
                                                </div>
                                                <div *ngIf="submitted &&  formGroupId.controls['cityName'].invalid 
                                        && (formGroupId.controls['cityName'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="formGroupId.controls['cityName'].errors.required">
                                            <b> City is required.</b>
                                        </div>  
                                    </div> 
                                                </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="grivZipCode" class="required">PIN Code <span
                                                class="text-danger">*</span></label>
                                        <input id="pinCode" name="pinCode" placeholder="PIN Code"
                                            formControlName="pinCode" class="form-control" type="text" value=""
                                            maxlength="6" (keypress)="keyPresspincode($event)">
                                            <div *ngIf="submitted &&  formGroupId.controls['pinCode'].invalid "
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('required')"
                                        class="failed-validation" class="errorColor">
                                        PIN Code is Required
                                    </div>
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('maxlength')" class="failed-validation" class="errorColor">
                                            <b> PIN Code cannot be more than 10 characters long. </b>
                                        </div> 
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('minlength')" class="failed-validation" class="errorColor">
                                            <b> PIN Code cannot be less than 6 characters long. </b>
                                        </div>
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].errors.pattern">
                                            <b>PIN Code should be a number  </b>
                                        </div> 
                                    </div>

                                    </div>
                                </div>
                                
                                <div class="row">

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="phoneNo" class="required">Mobile Number <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="mobileNo"
                                                formControlName="mobileNumber" placeholder="Mobile Number"
                                                (keypress)="keyPresspincode($event)" maxlength="10"
                            [ngClass]="{ 'is-invalid': f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched) }"
                            (keypress)="keyPress($event)"
                            data-validation-error-msg='Mobile Number is required'  data-validation-regexp="^[2-9][0-9]*$" data-validation="required length number custom" data-validation-length="10-10"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['mobileNumber'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Mobile Number Required
                        </div>
                        <div *ngIf="formGroupId.controls['mobileNumber'].hasError('pattern')"
                            class="failed-validation" class="errorColor">
                            Mobile Number should have starts with 9,8,7,6 and length 10 digits
                        </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="phoneNo" class="required">Landline Number <span
                                                    class="text-danger"></span></label>
                                            <input type="text" class="form-control" id="landlineNo"
                                                formControlName="landlineNumber" placeholder="Landline Number "
                                                (keypress)="keyPresspincode($event)"
                            [ngClass]="{ 'is-invalid': f.landlineNumber.invalid && (f.landlineNumber.dirty || f.landlineNumber.touched) }"
                            (keypress)="keyPress($event)"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['landlineNumber'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            Landline Number Required
                        </div>
                        
                        <div *ngIf="formGroupId.controls['landlineNumber'].hasError('pattern')"
                            class="failed-validation" class="errorColor">
                            Landline number should have atleast length 10 digits
                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                       

                                         
                                    </div>
                                    <div class="col-md-6">

                                       
 
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">

                                        <!-- <button type="submit" class="btn btn-danger" style="float: right;"
                                            routerLink="../login" (click)="back()"> -->
                                            <button type="submit" class="btn btn-danger" style="float: right;"
                                             (click)="back()">
                                            Cancel
                                        </button>&nbsp;
                                        <button type="submit" id="grSubmit" class="btn btn-success" (click)="onSubmit()"
                                            style="float: right; margin-right: 5px">
                                            Submit
                                        </button>&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>

                                <div style="text-align: right;" class="col-12 form-group mg-t-8">
                                    <p style="float: left;"> College/Already registered user, click here to </p>
                                    <button style="float: left;" type="button" class="btn btn-primary mx-2" (click)="redirectTo()">Login</button>
                                </div>

                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>